import { render, staticRenderFns } from "./list-skeleton.vue?vue&type=template&id=47aeb422"
import script from "./list-skeleton.vue?vue&type=script&lang=js"
export * from "./list-skeleton.vue?vue&type=script&lang=js"
import style0 from "./list-skeleton.vue?vue&type=style&index=0&id=47aeb422&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports